import { applyMiddleware, createStore } from "redux";
import redux from "redux";
import thunk from "redux-thunk";

import { IState } from "../classes/state";
import rootReducer from "../reducers";
import defState from "../reducers/initialState";

// Redux 4 changed the types for createStore() to require the default state to passed as a `<DeepPartial>(IState)`, but I cannot get this to work.
// As a workaround, I'm extending the type definition for StoreCreator to allow just passing the IState object, instead of <DeepPartial>(IState)
// tslint:disable
declare module "redux" {
  export interface StoreCreator {  // tslint:disable-line
    <S, A extends Action, Ext, StateExt>(reducer: Reducer<S, A>, preloadedState: S, enhancer?: StoreEnhancer<Ext>): Store<S & StateExt> & Ext;
  }
}
// tslint:enable

export default function configureStore(initialState: IState = defState): any {
  return createStore<IState, any, any, {}>(
    rootReducer,
    initialState,
    applyMiddleware(thunk),
  );
};
